import Moment from "moment/moment";
import Calendar from "./calendar.model";
import CalendarData from "./calendar-data.model";

export default class MonthCalendar extends Calendar {

    constructor(calendar) {
        super(calendar);

        this._withSunday = calendar && calendar.withSunday || false;
        this.init();
    }

    init() {
        this.cols = [];
        this.rows = [];

        let firstWeek = Moment(this.date).startOf('month').startOf('week');

        let days = this.withSunday ? 7 : 6;
        for (let d = 1; d <= days; ++d) {
            this.cols.push(new CalendarData({
                date: Moment(firstWeek).isoWeekday(d),
                timeUnit: 'day'
            }));
        }

        let lastWeek = Moment(this.date).endOf('month').startOf('week');
        let weeks = lastWeek.diff(firstWeek, 'week');

        for (let w = 0; w <= weeks; ++w) {
            this.rows.push(new CalendarData({
                date: Moment(firstWeek).add(w, 'week'),
                timeUnit: 'week'
            }));
        }

        super.onInitComplete();
    }

    onDateUpdated(oldDate) {
        let update = this.date.year() != oldDate.year()
            || this.date.month() != oldDate.month();

        if (update) {
            this.init();
        }
    }

    set withSunday(withSunday) {
        let update = this._withSunday != withSunday;
        if (update) {
            this._withSunday = withSunday;
            this.init();
        }
    }


    get withSunday() {
        return this._withSunday;
    }

    formatColTitle(col) {
        return Moment(col.date).format('dd');
    }

    formatRowTitle(row) {
        return "";
    }

    formatCellTitle(col, row) {
        return this.cellDate(col, row).format("DD");
    }

    isCellDisabled(col, row) {
        return !this.date.isSame(this.cellDate(col, row), 'month');
    }

    cellDate(col, row) {
        return Moment(row.date).isoWeekday(col.date.isoWeekday())
    }

    isCurrentDay(col, row) {
        return Moment().isSame(this.cellDate(col, row), 'day');
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/components/calendar/model/month-calendar.model.js